import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SwProcessingService } from '../shared/services/sw-processing.service';

@Injectable()
export class SwProcessingInterceptor implements HttpInterceptor {
  constructor(private swProcessingService: SwProcessingService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.swProcessingService.start();
    return next.handle(req).pipe(
      finalize(() => this.swProcessingService.stop())
    );
  }
}
